// test2399
(2399 && 0);
